import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import test_icon from "./images/test.png";
import test_list_icon from "./images/test-list.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import Card from "react-bootstrap/Card";
import ApiService from "../../_services/ApiService";
import Loader from "./../../_components/loader/loader";
import UserService from "../../_services/UserService";
import Config from "../../_config/config";
import { AppPropertiesContext } from "../../contexts/app-properties.context";
import "./testList.styles.css";

class TestList extends Component {
  static contextType = AppPropertiesContext;
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      message: null,
      loading: false,
      testCacheUrl: "",
      fetchError: null,
    };
    this.reloadTestList = this.reloadTestList.bind(this);
  }

  componentDidMount() {
    let paramsString = this.props.location.search;
    const params = new URLSearchParams(paramsString);
    let enquiryId = params.get("enquiryId");
    if (enquiryId) {
      localStorage.setItem("enquiryId", enquiryId);
    }
    this.reloadTestList(this.props?.location?.state?.portlet?.targeturl);
  }

  reloadTestList(url) {
    //var testlist = JSON.parse(localStorage.getItem('testlist')) || [];
    /*if(testlist.length > 0){
      this.setState({
        loading: false,
        list: testlist
      }); 
    }else{*/

    if (!url) url = sessionStorage.getItem("testCacheUrl");

    if (url) {
      console.log(url);
      url = url.replace("{enquiryId}", UserService.getEnquiryId);
      this.setState({ testCacheUrl: url });
    }

    this.setState({ loading: true }, () => {
      ApiService.fetchTestList(url && url !== "undefined" ? url : null)
        .then((res) => {
          this.setState({
            loading: false,
            list: res.data,
            fetchError: null
          });
          localStorage.setItem("testlist", JSON.stringify(res.data));

          if (res?.data[0]?.categoryBased === false) return;
          if(res?.data?.length !== 1) return;
          if (res.data[0]?.categoryBeans.length === 1) {
            // console.log(res.data[0].id,'testid');
            this.routeReplace(
              "/TestList/" + res.data[0]?.categoryBeans[0]?.id,
              res.data[0]?.id,
              {
                testListData: res.data,
                testCacheUrl: url ? url : null,
              }
            );
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({ fetchError: err, loading: false });
          setTimeout(() => {
            this.reloadTestList(url ? url : null);
          }, 5000);
        });
    });
    /*}*/
  }

  logout = () => {
    const loginRoute = sessionStorage.getItem("loginRoute");
    this.props.history.push({
      pathname: "/logout",
      state: { redirectRoute: loginRoute || "/" },
    });
  };

  routeReplace(path, test_parentcat_id, state) {
    console.log("here at replace");
    localStorage.setItem("test_parentcat_id", test_parentcat_id);
    if (!state) {
      this.props.history.replace({ pathname: path });
    } else {
      this.props.history.replace({ pathname: path, state });
    }
  }

  routeChange(path, test_parentcat_id, state) {
    localStorage.setItem("test_parentcat_id", test_parentcat_id);
    if (!state) {
      this.props.history.push(path);
    } else {
      this.props.history.push({ pathname: path, state });
    }
  }

  downloadSolution() {
    let token = UserService.getToken();
    // https://unacademy.edusquares.com/unacademy/popup/studentTestResult.do?reqCode=generateStudentDosier&token=eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIxNDciLCJqdGkiOiIxNDciLCJpYXQiOjE2MTM5OTY0NzAsInVzZXJuYW1lIjoiMjIxMDAwNzAwIiwiZW5xdWlyeUlkIjoxNDEsInJvbGVzIjpbIlN0YW5kYXJkU3R1ZGVudCJdLCJ0ZW5hbnQiOiJ1bmFjYWRlbXkifQ.w4DRLK_1HwSfxQy_LU5lCLZ-UR6vGsZKVaD3C4lAsYg
    window.open(
      `${Config.siteUrl}${Config.siteTitle}/popup/studentTestResult.do?reqCode=generateStudentDosier&token=${token}`
    );
  }

  render() {
    let portlet = JSON.parse(localStorage.getItem("portlet")) || [];
    const homeRoute = sessionStorage.getItem("homeRoute");
    const { loading, fetchError } = this.state;
    const { hideStudentDossier } = this.context;
    return (
      <div className="TestList">
        {
          <Container fluid>
            <div className="module-header">
              <div
                className={`module-header-inner ${
                  portlet.class ? portlet.class : "test-list-default-portlet"
                }`}
              >
                <div className="back">
                  {homeRoute === "/TestList" ? null : (
                    <FontAwesomeIcon
                      icon={faArrowLeft}
                      onClick={() => this.routeChange("/")}
                    />
                  )}
                  <span className="test-list-logout" onClick={this.logout}>
                    Logout
                  </span>
                </div>
                <img src={test_icon} alt="test icon" />
              </div>
              <div className="arrow-set test-listing-arrow-set">
                <h4>Online Tests</h4>
                {hideStudentDossier ? null : (
                  <span
                    className="view-solution test-listing-download-solution"
                    onClick={this.downloadSolution}
                  >
                    My dossier{" "}
                  </span>
                )}
              </div>
            </div>
            {fetchError ? (
              <div className="test-list-error-wrapper">
                <span>
                  Uh oh, it looks like you're facing a connectivity issue to the
                  server.
                </span>
                <span>
                  Don't worry, we're trying to reload the page for you.... 
                </span>
                <span>
                  If you'd like to try refreshing manually, <span onClick={()=>window.location.reload()} className="test-details-logout">click here.</span>
                </span>
              </div>
            ) : loading ? (
              <Loader />
            ) : (
              this.renderCard()
            )}
          </Container>
        }
      </div>
    );
  }

  renderCard() {
    let data = this.state.list;
    const { testCacheUrl } = this.state;
    console.log(data, Array.isArray(data), "data..");
    return (
      <div className="card_list">
        {Array.isArray(data) &&
          data?.map((item, index) => {
            return (
              <div>
                {data[index].categoryBased === true ? (
                  data[index].categoryBeans.map((c, i) => (
                    <Card
                      onClick={() =>
                        this.routeChange(
                          "/TestList/" + c.id,
                          data[index].id,
                          testCacheUrl ? { testCacheUrl: testCacheUrl } : null
                        )
                      }
                    >
                      <Card.Body>
                        <div className="cardbody">
                          <img src={test_list_icon} alt={c.name} />
                          <h4 className="head">{c.name}</h4>
                          <FontAwesomeIcon icon={faArrowRight} />
                        </div>
                      </Card.Body>
                    </Card>
                  ))
                ) : (
                  <Card
                    onClick={() =>
                      this.routeChange("/TestList/" + data[index].id, 0)
                    }
                  >
                    <Card.Body>
                      <div className="cardbody">
                        <img src={test_list_icon} alt={data[index].name} />
                        <h4 className="head">{data[index].name}</h4>
                        <FontAwesomeIcon icon={faArrowRight} />
                      </div>
                    </Card.Body>
                  </Card>
                )}
              </div>
            );
          })}
      </div>
    );
  }
}

export default TestList;
